import { render, staticRenderFns } from "./ReportMatter.vue?vue&type=template&id=5a2c642e&scoped=true"
import script from "./ReportMatter.vue?vue&type=script&lang=js"
export * from "./ReportMatter.vue?vue&type=script&lang=js"
import style0 from "./ReportMatter.vue?vue&type=style&index=0&id=5a2c642e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2c642e",
  null
  
)

export default component.exports